import { render, staticRenderFns } from "./HomeList.vue?vue&type=template&id=38515a32&scoped=true&lang=pug"
import script from "./HomeList.vue?vue&type=script&lang=js"
export * from "./HomeList.vue?vue&type=script&lang=js"
import style0 from "./HomeList.vue?vue&type=style&index=0&id=38515a32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38515a32",
  null
  
)

export default component.exports